const white = '#ffffff'
const black = '#584F62'
const mainGreen = 'rgb(50,197,174)'
const yellow254 = 'rgb(254,220,150)'
const rgb51 = 'rgb(51, 51, 51)'
const gray206 = 'rgb(206, 206, 206)'
const gray245 = 'rgb(245, 245, 245)'


export const WHITE = white
export const BLACK = black
export const GREEN50 = mainGreen
export const YELLOW254 = yellow254
export const RGB51 = rgb51
export const GRAY206 = gray206
export const GRAY245 = gray245

export const ARTICLE_CATEGORY_MAP = {
    'NEWS': '最新资讯',
    'HEALTH_FOOD': '健康饮食',
    'EXPERT_LECTURES': '专家讲座',
    'FAMILY_GROUP': '糖友家园',
    'KNOW_BG': '了解血糖',
    'USE_GUIDE': '用户使用指南'
  }


// WEBPACK FOOTER //
// ./src/common/constants.js